import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  MessageBox,
  // useTitle,
  MotionDiv,
  CustomTable,
  ViewButton,
  DeleteButton,
} from "../../components";
import { getError } from "../../utils/error";
// import { useDispatch, useSelector } from "react-redux";
// import { hideLoading, showLoading } from "../../features/loadingSlice";
// import axiosInstance from "../../utils/axiosUtil";
import { Col, Row } from "react-bootstrap";
import CountCard from "../../components/layout/CountCard";
// import { selectAuth } from "../../features/authSlice";
import {
  useDeleteTicketMutation,
  useGetAdminTicketMutation,
} from "../../features/apiSlice";
import ModalTemplate from "../../components/modals/ModalTemplate";
import DateTimeFormater from "../../components/layout/DateTimeFormatter";

export default function Tickets() {
  const navigate = useNavigate();
  const [getAdminTicket, { isLoading }] = useGetAdminTicketMutation();
  const [
    deleteTicket,
    {
      isLoading: { deleteTicketLoading },
    },
  ] = useDeleteTicketMutation();
  const [error, setError] = useState(null);
  const [usersCount, setUsersCount] = useState([]);
  const [curPage, setCurPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [query, setQuery] = useState("");
  const [tickets, setTickets] = useState([]);
  const [deleteId, setDeleteId] = useState("");

  const [showCancelModal, setShowCancelModal] = useState(false);
  const handleShowCancelModal = () => setShowCancelModal(true);
  const handleCloseCancelModal = () => setShowCancelModal(false);

  const curPageHandler = (p) => setCurPage(p);

  // const viewDetails = "/admin/tickets/details";

  const numOfPages = Math.ceil(usersCount / resultPerPage);
  const skip = resultPerPage * (curPage - 1);

  const column = [
    "No.",
    "Raised By",
    "Email",
    "Subject",
    "Speciality",
    // "Prof Name",
    "Status",
    "Ticket Raised On",
    "Actions",
  ];

  useEffect(() => {
    fetchTickets();
  }, [query]);

  const fetchTickets = async () => {
    try {
      const { data } = await getAdminTicket({ status: "", query });
      setTickets(data);
    } catch (error) {
      getError(error);
    }
  };

  const handleDeleteTicket = (id) => {
    handleShowCancelModal();
    setDeleteId(id);
  };

  const handleDelete = async (id) => {
    try {
      await deleteTicket(deleteId);
      fetchTickets();
      handleCloseCancelModal();
    } catch (error) {
      getError(error);
    }
  };

  return (
    <MotionDiv>
      {error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <ModalTemplate
            show={showCancelModal}
            onHide={handleCloseCancelModal}
            title={`Are you sure you want to delete this ticket?`}
            // description={
            //   "Lorem ipsum dolor sit amet consectetur. Suscipit nunc tincidunt iaculis sit feugiat platea. Aliquet amet cras amet mauris neque facilisi. Scelerisque interdum elit maecenas."
            // }
            src={"/icons/deleteIcon.png"}
            onDiscard={handleCloseCancelModal}
            onConfirm={handleDelete}
            loading={deleteTicketLoading}
            color={true}
            deleteBtn={true}
          />

          <Row>
            <CountCard
              title={"Total Tickets Raised"}
              // count={tickets.totalTickets && tickets.totalTickets}
              monthValue={tickets?.totalMonthlyTickets}
              yearValue={tickets?.totalTickets}
              loading={isLoading}
              dropdown={true}
              color="var(--purple-color)"
            />
            <CountCard
              title={"Open Tickets"}
              textColor="#01C739"
              // count={tickets.openTicket && tickets.openTicket}
              viewDetails={'/admin/tickets/details/Open Ticket'}
              loading={isLoading}
              monthValue={tickets?.monthlyOpenTickets}
              yearValue={tickets?.openTicket}
              dropdown={true}
              color="var(--green-color)"
            />
            <CountCard
              title={"Pending Tickets"}
              textColor="#FF9C06"
              viewDetails={'/admin/tickets/details/Pending Ticket'}
              loading={isLoading}
              monthValue={tickets?.monthlyPendingTickets}
              yearValue={tickets?.pendingTicket}
              dropdown={true}
              color="var(--yellow-color)"
            />
            <CountCard
              title={"Closed Tickets"}
              textColor="#737373"
              viewDetails={'/admin/tickets/details/Closed Ticket'}
              loading={isLoading}
              monthValue={tickets?.monthlyCloseTicket}
              yearValue={tickets?.closeTicket}
              dropdown={true}
              color="var(--gray-color)"
            />
            
          </Row>

          <CustomTable
            loading={isLoading}
            column={column}
            rowNo={resultPerPage}
            rowProps={{ setResultPerPage }}
            paging={numOfPages > 0}
            pageProps={{ numOfPages, curPage }}
            pageHandler={curPageHandler}
            search={true}
            searchProps={{ searchInput, setSearchInput, setQuery }}
            isTitle="true"
            title="User Details"
          >
            {tickets?.success &&
              tickets?.tickets?.map((ticket, i) => (
                <tr key={ticket?._id} className="odd">
                  <td className="text-center">{skip + i + 1}</td>
                  {/* <td>{ticket?.ticketId}</td> */}
                  <td>
                    {ticket?.from?.first_name} {ticket?.from?.last_name}
                  </td>
                  <td>{ticket?.from?.email}</td>
                  <td>{ticket?.subject}</td>
                  <td>{ticket?.subdomain?.sub_domain_name}</td>
                  {/* <td>{ticket?.to?.name}</td> */}
                  <td 
                    
                  >
                  <div className="rounded-pill" 
                  style={{
                    color: `${
                      ticket?.status === "Open"
                        ? "var(--text-completed)"
                        : ticket?.status === "Pending"
                        ? "var(--text-pending)"
                        : "var(--text-closed)"
                    }`,
                    backgroundColor: `${
                      ticket?.status === "Open"
                        ? "var(--bg-completed)"
                        : ticket?.status === "Pending"
                        ? "var(--bg-pending)"
                        : "var(--bg-closed)"
                    }`,
                  }}
                  >{ticket?.status}</div>
                  </td>
                  <td>{<DateTimeFormater timeReq={false} createdAt={ticket?.createdAt}/>}</td>
                  <td>
                    <ViewButton
                      onClick={() =>
                        navigate(`/admin/ticket/chat/${ticket?._id}`)
                      }
                    />
                    <DeleteButton
                      onClick={() => {
                        handleDeleteTicket(ticket?._id);
                      }}
                    />
                  </td>
                </tr>
              ))}
          </CustomTable>
        </>
      )}
      <ToastContainer />
    </MotionDiv>
  );
}
